export default "__VITE_ASSET__ed50ae27__"